<template>
    <v-dialog v-model="dialog" max-width="1300px" persistent @keydown.esc="chiudiDialogMat()">
        <v-card>
            <v-card-title class="headline">
                Gestione materiale in ingresso
                <v-spacer />
                <v-btn icon @click="chiudiDialogMat()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-form ref="form" v-model="formValid">
                    <v-container fluid>
                        <v-row>
                            <v-col cols="6" sm="6" md="6">
                                <v-text-field label="Fornitore" v-model="elemento.Fornitore" :rules="[rules.required]"
                                    dense />
                            </v-col>
                            <v-col cols="3" sm="6" md="3">
                                <v-text-field label="DDT" v-model="elemento.NBolla" :rules="[rules.ddtOrFattura]"
                                    dense />
                                <v-text-field v-model="elemento.DataBolla" type="date" dense outlined class="mt-2"
                                    color="primary" label="Data DDT" />
                            </v-col>
                            <v-col cols="3" sm="6" md="3">
                                <v-text-field label="Fattura" v-model="elemento.NFattura" :rules="[rules.ddtOrFattura]"
                                    dense />
                                <v-text-field v-model="elemento.DataFattura" type="date" dense outlined class="mt-2"
                                    color="primary" label="Data Fattura" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="4" md="4">
                                <v-select label="Gruppo di prodotto" v-model="elemento.GruppoCategoriaFSC"
                                    :items="gruppiProdotto"
                                    :item-text="item => item.codGruppo + ' - ' + item.traduzione" item-value="codGruppo"
                                    return-object :rules="[rules.required]" dense />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-autocomplete :items="essenze" label="Essenza" v-model="elemento.Essenza"
                                    :rules="[rules.required]" dense />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <v-select label="Dichiarazione FSC" v-model="elemento.DichiarazioneFSC"
                                    :items="dichiarazioniFSC" item-text="descrizione" item-value="idDichiarazione"
                                    return-object :rules="[rules.required]" dense />
                            </v-col>
                        </v-row>

                        <v-row v-if="mostraMisure">
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field label="Pezzi" v-model.number="elemento.Pezzi" type="number"
                                    :rules="[rules.numeroPositivo]" dense />
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field label="Sezione (mm)" v-model.number="elemento.Sezione" type="number"
                                    :rules="[rules.numeroPositivo]" dense />
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field label="Spessore (mm)" v-model.number="elemento.Spessore" type="number"
                                    :rules="[rules.numeroPositivo]" dense />
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field label="Lunghezza (mm)" v-model.number="elemento.Lunghezza" type="number"
                                    :rules="[rules.numeroPositivo]" dense />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="3" md="2">
                                <v-autocomplete :items="um" label="Unità Misura" v-model="elemento.UM" hide-details
                                    dense :rules="[rules.required]" />
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-text-field label="QTA" v-model="elemento.Qta" type="number" hide-details dense
                                    :rules="[rules.required]" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field label="Descrizione" v-model="elemento.Descrizione" hide-details />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn icon color="error" @click="eliminaMatPrima()" :disabled="elemento.IdMateriale <= 0">
                    <v-icon>delete</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn @click="chiudiDialogMat()" text>Annulla</v-btn>
                <v-btn color="primary" @click="salva" :disabled="salvataggioInCorso" :loading="salvataggioInCorso">
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { set_materiale, del_materiale, get_gruppi_prodotto, get_dichiarazioni, get_um, get_essenze } from '@/api/api.registroSintesi.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
        editItem: { type: Object, default: () => ({}) },
    },

    data() {
        return {
            tabs: 0,
            elemento: {},
            formValid: false,
            salvataggioInCorso: false,

            gruppiProdotto: [],
            dichiarazioniFSC: [],
            um: [],
            essenze: [],

            rules: {
                required: v => !!v || 'Campo obbligatorio',
                ddtOrFattura: v => {
                    // Almeno uno tra DDT e Fattura deve essere compilato
                    if (this.elemento.NBolla || this.elemento.NFattura) {
                        return true;
                    }
                    return 'Inserire almeno DDT o Fattura';
                },
                numeroPositivo: v => {
                    if (v === null || v === undefined || v === '') return true;
                    return v > 0 || 'Deve essere un numero positivo';
                }
            }
        }
    },

    methods: {
        chiudiDialogMat(salva = false) {
            if (!salva) {
                this.$refs.form?.reset();
            }
            this.$emit("close", salva);
        },

        async salva() {
            // Validazione form
            if (!this.$refs.form.validate()) {
                this.$toast.alert("Compilare tutti i campi obbligatori");
                return;
            }

            // Validazione aggiuntiva: almeno uno tra DDT e Fattura
            if (!this.elemento.NBolla && !this.elemento.NFattura) {
                this.$toast.alert("Inserire almeno il numero DDT o il numero Fattura");
                return;
            }

            this.salvataggioInCorso = true;

            try {
                // Normalizzazione date vuote
                const elementoDaSalvare = { ...this.elemento };
                if (elementoDaSalvare.DataFattura === "") elementoDaSalvare.DataFattura = null;
                if (elementoDaSalvare.DataBolla === "") elementoDaSalvare.DataBolla = null;

                const res = await set_materiale(elementoDaSalvare);

                if (res.data === "OK") {
                    this.chiudiDialogMat(true);
                } else {
                    this.$toast.error("Errore durante il salvataggio: " + res.data);
                }
            } catch (error) {
                console.error("Errore durante il salvataggio:", error);
                this.$toast.error("Errore durante il salvataggio del materiale");
            } finally {
                this.salvataggioInCorso = false;
            }
        },

        async caricaDati() {
            try {
                let par = "";
                if (this.role !== "utente") {
                    par = "?companyCode=" + this.compCode;
                }

                const [gruppiRes, dichiarazioniRes, umRes, essenzeRes] = await Promise.all([
                    get_gruppi_prodotto(par),
                    get_dichiarazioni(par),
                    get_um(),
                    get_essenze()
                ]);

                this.gruppiProdotto = gruppiRes.data;
                this.dichiarazioniFSC = dichiarazioniRes.data;
                this.um = umRes.data;
                this.essenze = essenzeRes.data;
            } catch (error) {
                console.error("Errore durante il caricamento dei dati:", error);
                this.$toast.error("Errore durante il caricamento dei dati");
            }
        },

        async eliminaMatPrima() {
            if (!this.elemento.IdMateriale) {
                this.$toast.alert("Nessun elemento da eliminare");
                return;
            }

            const confirm = await this.$confirm.open("Elimina", "Eliminare l'elemento corrente?");
            if (!confirm) return;

            this.salvataggioInCorso = true;

            try {
                const elementoDaEliminare = { ...this.elemento };
                if (elementoDaEliminare.DataFattura === "") elementoDaEliminare.DataFattura = null;
                if (elementoDaEliminare.DataBolla === "") elementoDaEliminare.DataBolla = null;

                const res = await del_materiale(elementoDaEliminare);

                if (res.data === "OK") {
                    this.chiudiDialogMat(true);
                } else {
                    this.$toast.error("Errore durante l'eliminazione: " + res.data);
                }
            } catch (error) {
                console.error("Errore durante l'eliminazione:", error);
                this.$toast.error("Errore durante l'eliminazione del materiale");
            } finally {
                this.salvataggioInCorso = false;
            }
        }
    },

    watch: {
        editItem: {
            handler(newVal) {
                this.elemento = { ...newVal };
                if (this.elemento.DataFattura) {
                    this.elemento.DataFattura = this.elemento.DataFattura.substring(0, 10);
                }
                if (this.elemento.DataBolla) {
                    this.elemento.DataBolla = this.elemento.DataBolla.substring(0, 10);
                }
                this.caricaDati();
            },
            immediate: true
        },

        dialog(newVal) {
            if (newVal) {
                // Reset validazione quando si apre il dialog
                this.$nextTick(() => {
                    this.$refs.form?.resetValidation();
                });
            }
        }
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },

        mostraMisure() {
            return this.elemento.GruppoCategoriaFSC &&
                (this.elemento.GruppoCategoriaFSC.codGruppo === 'W9.1' ||
                    this.elemento.GruppoCategoriaFSC.codGruppo === 'W9.6' ||
                    this.elemento.GruppoCategoriaFSC.codGruppo === 'W5.2' ||
                    this.elemento.GruppoCategoriaFSC.codGruppo === 'W6.1');
        }
    },
}
</script>